import React from "react";
import { Radio, Cpu, Smartphone, Wrench } from "lucide-react";

const steps = [
  {
    n: "01",
    icon: Radio,
    title: "Wireless Sensors",
    body: "Tamper-proof sensors installed inside overhead + underground tanks send water levels every 2 seconds over encrypted radio.",
  },
  {
    n: "02",
    icon: Cpu,
    title: "Smart Controller",
    body: "The Aquamatic controller runs safety logic — dry-run cutoff, overflow prevention, phase-fail lockout, duty rotation.",
  },
  {
    n: "03",
    icon: Smartphone,
    title: "Mobile Monitoring",
    body: "AquaCloud app streams live tank levels, pump status and alerts to residents, security, and facility managers.",
  },
  {
    n: "04",
    icon: Wrench,
    title: "Zero-touch AMC",
    body: "Certified engineers commission, calibrate and remotely maintain the system — with an SLA-backed uptime guarantee.",
  },
];

export default function HowItWorks() {
  return (
    <section id="how" className="border-b border-zinc-200 bg-[#F4F4F5]">
      <div className="px-6 md:px-12 lg:px-24 py-24 md:py-32">
        <div className="max-w-3xl mb-16">
          <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#002FA7] mb-4">
            /// How It Works
          </div>
          <h2 className="text-4xl sm:text-5xl font-semibold tracking-tight leading-tight">
            Four moving parts. One reliable system.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border border-zinc-300 bg-white">
          {steps.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.n}
                className={`p-8 ${i < steps.length - 1 ? "border-b md:border-b lg:border-b-0 lg:border-r border-zinc-300" : ""} ${
                  i < 2 ? "md:border-r" : ""
                } md:[&:nth-child(3)]:border-r-0 lg:[&:nth-child(3)]:border-r`}
              >
                <div className="flex items-center justify-between mb-6">
                  <span className="font-mono text-4xl font-light text-zinc-300">{s.n}</span>
                  <Icon className="w-6 h-6 text-[#002FA7]" strokeWidth={1.8} />
                </div>
                <h3 className="text-xl font-semibold tracking-tight">{s.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-zinc-600">{s.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
